import React, { useState, useEffect } from 'react';
import CRUDList from '../Common/CRUDList';
import DateInput from '../Common/DateInput';
import { carrierCodes, carriers } from '../../services/api';

const codeTypes = {
  1: 'IATA',
  2: 'ICAO'
};

function CarrierCodeForm({ formData, setFormData }) {
  const [carriersList, setCarriersList] = useState([]);

  useEffect(() => {
    loadCarriers();
  }, []);

  const loadCarriers = async () => {
    try {
      const response = await carriers.getAll();
      setCarriersList(response.data);
    } catch (err) {
      console.error('Failed to load carriers', err);
    }
  };

  return (
    <>
      <div className="form-group">
        <label>Carrier *</label>
        <select
          value={formData.ccode_carrier_id || ''}
          onChange={(e) => setFormData({ ...formData, ccode_carrier_id: parseInt(e.target.value) })}
          required
        >
          <option value="">Select carrier</option>
          {carriersList.map(carrier => (
            <option key={carrier.carrier_id} value={carrier.carrier_id}>
              {carrier.carrier_name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Code Type *</label>
        <select
          value={formData.ccode_type || ''}
          onChange={(e) => setFormData({ ...formData, ccode_type: parseInt(e.target.value) })}
          required
        >
          <option value="">Select type</option>
          <option value="1">IATA</option>
          <option value="2">ICAO</option>
        </select>
      </div>

      <div className="form-group">
        <label>Code Value *</label>
        <input
          type="text"
          value={formData.ccode_value || ''}
          onChange={(e) => setFormData({ ...formData, ccode_value: e.target.value.toUpperCase() })}
          maxLength={3}
          required
        />
      </div>

      <div className="form-group">
        <label>Valid From</label>
        <DateInput
          value={formData.ccode_valid_from || ''}
          onChange={(value) => setFormData({ ...formData, ccode_valid_from: value })}
        />
      </div>

      <div className="form-group">
        <label>Valid To</label>
        <DateInput
          value={formData.ccode_valid_to || ''}
          onChange={(value) => setFormData({ ...formData, ccode_valid_to: value })}
        />
      </div>
    </>
  );
}

function CarrierCodesList() {
  return (
    <CRUDList
      title="Carrier Codes"
      api={carrierCodes}
      columns={['ID', 'Carrier', 'Type', 'Code', 'Valid From', 'Valid To']}
      FormComponent={CarrierCodeForm}
      defaultFormData={{ ccode_carrier_id: '', ccode_type: '', ccode_value: '', ccode_valid_from: null, ccode_valid_to: null }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.ccode_id}</td>
          <td>{item.carrier_name}</td>
          <td><span className="badge badge-info">{codeTypes[item.ccode_type]}</span></td>
          <td><strong>{item.ccode_value}</strong></td>
          <td>{item.ccode_valid_from || '-'}</td>
          <td>{item.ccode_valid_to || '-'}</td>
        </>
      )}
    />
  );
}

export default CarrierCodesList;
